// 42 Common Core 과제 카드의 수동 기입 데이터 (slug 별). scripts/fetch42Projects.mjs 가 만드는
// fortyTwoProjects.generated.json 과 fortyTwoProjects.js 의 buildFortyTwoExperiences() 에서 합쳐진다.
//
//   summaries: 동료평가 코멘트 원문(scripts/out/fortyTwo.evaluations.raw.json, 커밋 금지)을 읽고
//              Claude 가 통과 시점의 평가를 중심으로 3개로 요약한 것 (2026-10-06 작성)
//   skills:    카드 왼쪽 열의 Skills 칩. 기존 카드처럼 '#' 접두사. 없으면 GitHub languages 로 자동 생성된다
//   aboutKo:   GitHub About 이 영어일 때 카드에 대신 보여 줄 한국어 번역 (Claude 번역). 없으면 About 원문을 그대로 쓴다
//
// slug 는 API 의 '42cursus-' 접두사를 뗀 것 (libft, ft_printf, get_next_line, born2beroot, push_swap, fract-ol, minitalk)
export const fortyTwoCurated = {
  libft: {
    // GitHub About 원문(영어): "This project involves coding a C library that will include numerous general purpose functions
    // for my programs in the future as assignments by 42school. Its version is 19.0 including the Bonus part as mandatory as Part3."
    aboutKo: '42school 과제로, 앞으로 만들 프로그램들에서 쓸 범용 함수들을 모은 C 라이브러리를 직접 구현하는 프로젝트입니다. 버전 19.0 기준이며, 보너스 파트를 Part 3 필수 과제처럼 포함했습니다.',
    summaries: [
      '모든 함수가 정상 동작했고, 직접 만든 테스트 케이스로 검증할 수 있게 준비한 점이 인상적이었다는 평',
      '재도전 과정에서 무엇이 문제였고 어떻게 고쳤는지를 중심으로 설명해, 과제 요구 이상으로 이해하려는 태도가 돋보였다',
      '구현한 함수를 다른 함수에서 재활용하는 능력이 뛰어났다. 논리상 불필요한 코드 몇 곳은 개선 과제로 지적받았다'
    ],
    skills: ['#C언어', '#메모리관리', '#포인터', '#연결리스트', '#Makefile', '#라이브러리설계', '#테스트코드']
  },
  ft_printf: {
    // GitHub About 원문(영어): "# For? Helping me understand how printf() works by implementing it myself, and learn about using a variable
    // number of arguments, variadic functions in C. # Overview? This project involves recoding printf() for my programs in the future
    // as assignments by 42school. Its version is 12.1 without the Bonus part. # What? printf(), variadic functions in C"
    aboutKo: 'printf() 를 직접 구현해 그 동작 원리를 이해하고, C 의 가변 인자 함수(variadic function) 사용법을 익히는 것이 목적입니다. 42school 과제로, 앞으로 만들 프로그램들에서 쓸 printf() 를 다시 구현했습니다. 버전 12.1 기준이며 보너스 파트는 제외했습니다. 핵심 주제: printf(), C 의 가변 인자 함수.',
    summaries: [
      '다섯 번의 재도전 끝에 mandatory 테스터와 라이브 코딩(새 서식 지정자 추가)까지 모두 통과했다',
      'undefined behavior 에 대한 자기 기준을 세워 선언되지 않은 서식 지정자의 동작을 설명했고, 가변 인자마다 출력 수를 처리하는 방식이 영리하다는 평',
      '영문 README 와 코드에 대한 이해도가 평가에 도움이 됐고, libft 함수를 잘 활용해 printf 의 동작을 모사했다'
    ],
    skills: ['#C언어', '#가변인자', '#문자열처리', '#정적라이브러리', '#문서화', '#문제해결']
  },
  get_next_line: {
    // GitHub About 원문(영어): "This activity is about programming a function that returns a line read from a file descriptor.
    // Its version is 14.2 including the Bonus part."
    aboutKo: '파일 디스크립터에서 한 줄씩 읽어 반환하는 함수를 구현하는 과제입니다. 버전 14.2 기준이며 보너스 파트를 포함했습니다.',
    summaries: [
      'BUFFER_SIZE 를 바꿔 가며 동작해야 하는 이유를 실행 환경과 연관 지어 설명했고, 정적 변수를 용도에 맞게 활용했다',
      '보너스에서 backup 배열의 수와 파일 디스크립터 한도(1024)의 관계까지 설명할 만큼 꼼꼼히 준비했다',
      '여러 문장·단어·빈 파일 등 테스트 파일을 미리 준비해 한 번의 컴파일로 여러 상황을 보여 줘 평가 시간을 줄였다. 라이브 코딩도 통과'
    ],
    skills: ['#C언어', '#파일디스크립터', '#정적변수', '#버퍼관리', '#메모리관리', '#테스트코드']
  },
  born2beroot: {
    summaries: [
      '가상머신·파티션·보안·계정 관리 개념을 막힘없이 설명했고, 평가 기준에 맞게 동작을 시연했다',
      'fail2ban 을 추가 설치해 보안을 강화한 점이 인상적이었다는 평 (보너스 포함)',
      '새 사용자에게 SSH 권한을 부여하는 시연에서 한 번 막혔지만 끝까지 디펜스했다'
    ],
    skills: ['#리눅스', '#가상머신', '#시스템관리', '#보안', '#SSH', '#UFW', '#fail2ban', '#셸스크립트']
  },
  push_swap: {
    summaries: [
      '청크 기반 정렬에 탐욕 알고리즘을 결합해 최적화한 점이 인상적이었다는 평',
      '원형 버퍼와 출력 시 시스템 콜 횟수를 고려한 설계로 평가표의 성능 지표를 모두 충족했다',
      'README 에 배열과 연결 리스트 중 무엇을 쓸지 고민한 기록이 있어 코드에 대한 깊은 이해가 드러났다'
    ],
    skills: ['#C언어', '#알고리즘', '#자료구조', '#원형버퍼', '#정렬최적화', '#탐욕알고리즘', '#문서화']
  },
  'fract-ol': {
    // GitHub About 원문(영어): "A program that renders fractal graphics using the MiniLibX library. It visualizes the MandelbrotSet and JuliaSet
    // on a complex number plane with mouse wheel zoom in/out functionality. Core of this project lies in 1)Complex number mathematical
    // algorithm implementation 2)Communication with the X11 window server via MiniLibX 3)Rendering optimization"
    aboutKo: 'MiniLibX 라이브러리로 프랙탈 그래픽을 그리는 프로그램입니다. 복소평면 위에 Mandelbrot 집합과 Julia 집합을 시각화하고, 마우스 휠로 확대·축소할 수 있습니다. 핵심은 1) 복소수 수학 알고리즘 구현, 2) MiniLibX 를 통한 X11 윈도 서버와의 통신, 3) 렌더링 최적화입니다.',
    summaries: [
      'Mandelbrot·Julia 모두 valgrind 에서 누수 없이 동작했고, 네이밍이 깔끔해 코드가 읽기 편했다는 평',
      '프레임마다 시스템 콜을 한 번만 호출하는 방식으로 확대·반복 횟수 증가 시의 렌더링을 최적화했다',
      '복소평면과 점화식 발산 판정 원리를 평가자가 이해할 수 있게 설명했다. 공회전(busy waiting) 루프 구조는 개선 과제로 지적받았다'
    ],
    skills: ['#C언어', '#MiniLibX', '#그래픽스', '#복소수', '#최적화', '#이벤트처리', '#메모리관리']
  },
  // 시험: 동료평가가 없어 summaries 없음. 소개문은 scripts/fortyTwo.config.json 의 projects['exam-rank-02'].about
  'exam-rank-02': {
    skills: ['#C언어', '#알고리즘', '#문자열처리', '#포인터', '#시간관리', '#문제해결']
  },
  minitalk: {
    summaries: [
      'SIGUSR1·SIGUSR2 두 시그널만으로 두 프로세스 간 통신을 구현했고, 서버가 클라이언트의 값을 정확히 수신하는 것을 확인받았다',
      '보너스인 유니코드(이모지) 전송까지 여러 테스트에서 문제없이 동작했다',
      '상세한 README 와 간결한 코드, 차분한 설명 덕에 평가가 수월했다는 평. 평가자 3명 모두 Outstanding'
    ],
    skills: ['#C언어', '#유닉스시그널', '#프로세스간통신', '#비트연산', '#유니코드', '#문서화']
  }
};
